module.exports = __webpack_public_path__ + "static/media/polygon-select.9eff764c.svg";